/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import EventsEmitter from 'minivents';
/*:: import type {Store} from './Store.js'; */
import {getSeashotIds, getSeashotsWithIds} from './api.js';

export class SeashotsListFetcher {
  /*:: store: Store; */
  /*:: searchQuery: string; */
  /*:: offset: number; */
  /*:: limit: number; */
  ids /*: string[] */ = [];
  loading /*: boolean */ = false;

  hub /*: EventsEmitter */ = new EventsEmitter();

  constructor(
    store /*: Store */,
    searchQuery /*: string */,
    tag /*: string | undefined */,
    offset /*: number */ = 0,
    limit /*: number */ = 10
  ) {
    this.store = store;
    this.searchQuery = searchQuery;
    this.tag = tag;
    this.offset = offset;
    this.limit = limit;
  }

  loadIds() /*: void */ {
    let pendingIdText = '';

    this.loading = true;
    this.hub.emit('start');
    getSeashotIds(
      this.searchQuery,
      this.tag,
      (newText /*: string */) => {
        const ids = (pendingIdText + newText).split('\n');

        pendingIdText = ids.pop();

        this.ids = [...this.ids, ...ids];
        this.loadSeashots();
        this.hub.emit('progress');
      },
      () => {
        if (pendingIdText) {
          this.ids = [...this.ids, pendingIdText];
        }
        this.loadSeashots();
        this.loading = false;
        this.hub.emit('end');
      }
    );
  }
  loadSeashots() {
    const ids = this.ids.slice(this.offset, this.offset + this.limit);

    getSeashotsWithIds(ids);
    this.store.seashotsList = ids;
  }
}
